export const ACTIONS = {
  FETCH: 'fetch',
  CREATE: 'add',
  DELETE: 'delete',
  EDIT: 'edit',
  VIEW: 'view',

  REMINDER: {
      CREATE: 'reminder-create',
  }
}